import { useSelector } from 'react-redux'
import { selectCurrentAccessToken, selectCurrentUserRole } from '../../../features/auth/authSlice'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

interface RequireAuthProps {
    allowedRoles?: string[];
}

export default function RequireAuth({ allowedRoles = [] }: RequireAuthProps) {

    const location = useLocation();
    const accessToken = useSelector(selectCurrentAccessToken);
    const userRole = (useSelector(selectCurrentUserRole) ?? '').toLowerCase();

    if (!accessToken) {
        return <Navigate to="/login-staff" state={{ from: location }} replace />;
    }

    if (allowedRoles.length && !allowedRoles.includes(userRole)) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    return <Outlet />;
}
